import { useQuery } from "@tanstack/react-query";
import { z } from "zod";

import {
    dataPartSchema,
    type FundPagePartDataArgs,
} from "@hsl/core/fund-page/schemas";
import { getDataFromPart } from "@hsl/core/fund-page/services";

const footnoteSchema = z.object({
    footnote: dataPartSchema.extend({
        part: z.object({
            data: z.string(),
        }),
    }),
});

async function getFootnoteData(args: FundPagePartDataArgs) {
    const data = await getDataFromPart(args);
    const parse = footnoteSchema.safeParse(data);
    if (parse.success) {
        return parse.data.footnote.part.data;
    } else {
        console.error(parse.error);
    }
}

function useFootnote(args: FundPagePartDataArgs | null) {
    const { data, error, isLoading } = useQuery({
        queryKey: ["footer", args?.fundID ?? null],
        queryFn: async () => {
            if (args) {
                // in the case that the footnote is passed directly as a string
                if (typeof args.partId === "string") return args.partId;
                return (await getFootnoteData(args)) ?? null;
            } else {
                return null;
            }
        },
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        refetchInterval: false,
    });
    return {
        data,
        error,
        isLoading,
    };
}

export default useFootnote;
